
const digest = '6d774810350ec0d84bd045a5ab6896c47c38104d6f5ae9d0221b89bc45b5e4bf';
const classes = {"fileUpload":"_fileUpload_1xjfc_1","filePreview":"_filePreview_1xjfc_5","removeButton":"_removeButton_1xjfc_12","filePreviewBackground":"_filePreviewBackground_1xjfc_18","attachment":"_attachment_1xjfc_24","wrapper":"_wrapper_1xjfc_37","chatLanguage":"_chatLanguage_1xjfc_43","inputWrapper":"_inputWrapper_1xjfc_51","messageWrapper":"_messageWrapper_1xjfc_59","inputGroup":"_inputGroup_1xjfc_63","customFile":"_customFile_1xjfc_70","textArea":"_textArea_1xjfc_77","subMenu":"_subMenu_1xjfc_81","plusButton":"_plusButton_1xjfc_84","menu":"_menu_1xjfc_93","close":"_close_1xjfc_106","phrasesButton":"_phrasesButton_1xjfc_116","icon":"_icon_1xjfc_124"};
const css = `._fileUpload_1xjfc_1 {
  display: none;
}

._filePreview_1xjfc_5 {
  margin-left: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row-reverse;
  gap: 10px;
}
._filePreview_1xjfc_5 ._removeButton_1xjfc_12 {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

._filePreviewBackground_1xjfc_18 {
  background-repeat: no-repeat;
  background-position: center;
  border: 0;
}

._attachment_1xjfc_24 {
  background: url("/dist/icons/react/attachment.svg") no-repeat left;
  background-size: contain;
  cursor: pointer;
  display: flex;
  margin-bottom: 0;
  width: max-content;
  height: 30px;
  padding-left: 40px;
  align-items: center;
  font-size: 14px;
}

._wrapper_1xjfc_37 {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-top: 1px solid #eaedf3;
}
._wrapper_1xjfc_37 ._chatLanguage_1xjfc_43 {
  padding: 5px 24px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  background: #e9effb;
  color: #2b2f33;
}
._wrapper_1xjfc_37 ._inputWrapper_1xjfc_51 {
  padding: 24px;
  display: flex;
  flex-direction: row;
  gap: 9px;
  align-items: flex-end;
}

._messageWrapper_1xjfc_59 {
  flex-grow: 1;
}

._inputGroup_1xjfc_63 {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}

._customFile_1xjfc_70 {
  position: relative;
  display: inline-block;
  width: 100%;
  margin-bottom: 0;
}

._textArea_1xjfc_77 {
  margin-bottom: -3px;
}

._subMenu_1xjfc_81 {
  position: relative;
}
._subMenu_1xjfc_81 ._plusButton_1xjfc_84 {
  border-radius: 100%;
  width: 49px;
  height: 49px;
  background: #e9effb url("/dist/icons/react/plus-blue.svg") no-repeat center;
  background-size: 25px;
  cursor: pointer;
  aspect-ratio: 1/1;
}
._subMenu_1xjfc_81 ._menu_1xjfc_93 {
  position: absolute;
  padding: 24px 24px 48px 24px;
  background-color: #ffffff;
  border-radius: 25px;
  border: 1px solid #eaedf3;
  box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.1);
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._subMenu_1xjfc_81 ._menu_1xjfc_93 ._close_1xjfc_106 {
  position: absolute;
  right: 14px;
  bottom: 14px;
  width: 20px;
  height: 20px;
  background: url("/dist/icons/react/xmark-blue.svg") no-repeat center;
  background-size: contain;
  cursor: pointer;
}
._subMenu_1xjfc_81 ._menu_1xjfc_93 ._phrasesButton_1xjfc_116 {
  display: flex;
  align-items: center;
  gap: 10px;
  width: max-content;
  cursor: pointer;
  font-size: 14px;
}
._subMenu_1xjfc_81 ._menu_1xjfc_93 ._phrasesButton_1xjfc_116 ._icon_1xjfc_124 {
  border-radius: 100%;
  width: 30px;
  height: 30px;
  background: #e9effb url("/dist/icons/react/chat-lines-blue.svg") no-repeat center;
  background-size: 11px;
  cursor: pointer;
  aspect-ratio: 1/1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  